var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));

// components/accordion/common/src/accordion-props.ts
var accordionEmphases = ["bold", "subtle"];
var accordionSizes = ["sm", "md", "lg"];
var accordionDefaultProps = {
  emphasis: "subtle",
  size: "md"
};
var accordionPanelDefaultProps = {
  disabled: false,
  hideExpandIcon: false,
  defaultExpanded: false,
  toggleOnClick: true
};

// components/accordion/common/src/accordion-style-sheet.ts
import { StyleSheet } from "@gs-ux-uitoolkit-common/style";
import { createComponentClassDefinitions } from "@gs-ux-uitoolkit-common/theme";
var accordionStyleSheet = new StyleSheet(
  "accordion",
  (props) => {
    var _a;
    return createComponentClassDefinitions(
      props,
      createDefaultStyledClasses,
      (_a = props.theme.styleOverrides) == null ? void 0 : _a.accordion
    );
  }
);
function createDefaultStyledClasses() {
  return {
    root: {},
    accordion: {}
  };
}

// components/accordion/common/src/accordion-panel-style-sheet.ts
import { fontWeight } from "@gs-ux-uitoolkit-common/design-system";
import { StyleSheet as StyleSheet2 } from "@gs-ux-uitoolkit-common/style";
import { getIconStyles } from "@gs-ux-uitoolkit-common/icon-font";
import {
  createComponentClassDefinitions as createComponentClassDefinitions2
} from "@gs-ux-uitoolkit-common/theme";
var accordionPanelStyleSheet = new StyleSheet2(
  "accordion-panel",
  (props) => {
    var _a;
    return createComponentClassDefinitions2(props, createDefaultStyledClasses2, (_a = props.theme.styleOverrides) == null ? void 0 : _a.accordionPanel);
  }
);
function createDefaultStyledClasses2({
  theme,
  disabled = false,
  emphasis = accordionDefaultProps.emphasis,
  size = accordionDefaultProps.size,
  expanded,
  expandHidden
}) {
  const sizeVariant = accordionSizeVariants[size];
  const emphasisVariant = disabled ? getDisabledAccordionEmphasisVariants(theme)[emphasis] : getAccordionEmphasisVariants(theme)[emphasis];
  let headerStyle = {};
  if (disabled) {
    headerStyle = {
      opacity: theme.state.disabledOpacity,
      "*": {
        color: `${emphasisVariant.textColor} !important`
      }
    };
  }
  return {
    root: {
      overflow: "hidden",
      position: "relative",
      listStyle: "none",
      "&:last-child": __spreadValues({}, emphasis !== "bold" && {
        borderBottom: emphasisVariant.borderTop
      })
    },
    toggle: __spreadProps(__spreadValues(__spreadProps(__spreadValues({}, theme.typography[sizeVariant.typography]), {
      fontWeight: fontWeight.medium,
      backgroundColor: expanded ? `${emphasisVariant.expandedBackgroundColor} !important` : emphasisVariant.backgroundColor,
      cursor: disabled ? "default" : "pointer",
      color: expanded ? `${emphasisVariant.expandedColor} !important` : emphasisVariant.textColor,
      // Reduce top & bottom padding by 1px to account for the border
      padding: expandHidden ? `${sizeVariant.paddingY}px ${emphasisVariant.paddingX}px` : `
                ${sizeVariant.paddingY - 1}px 
                ${sizeVariant.paddingRight}px 
                ${sizeVariant.paddingY - 1}px 
                ${emphasisVariant.paddingX}px
            `,
      textDecoration: "none",
      boxSizing: "border-box",
      // Override button styles
      display: "block",
      width: "100%",
      textAlign: "left",
      border: "1px solid transparent",
      // Border styles
      borderTop: emphasisVariant.borderTop,
      borderBottom: emphasisVariant.borderBottom
    }), expanded && emphasis === "bold" && { borderBottom: `1px solid transparent` }), {
      "&:before": __spreadProps(__spreadValues({
        color: expanded ? emphasisVariant.expandedColor : emphasisVariant.toggleIconColor,
        position: "absolute",
        top: sizeVariant.toggleTop,
        right: sizeVariant.toggleRight
      }, getIconStyles({ name: "keyboard-arrow-down", type: "filled" })), {
        fontSize: sizeVariant.toggleFontSize,
        transform: expanded ? "rotateX(-180deg)" : "",
        display: expandHidden ? "none" : "inline-block"
      }),
      "&:hover": {
        backgroundColor: disabled ? "none" : emphasisVariant.hoverBackgroundColor,
        color: emphasisVariant.textColor,
        textDecoration: "none"
      },
      // a11y focus styles
      "&:focus-visible": {
        outline: "none",
        border: `1px solid ${theme.colorScheme.primary}`
      }
    }),
    header: __spreadValues({}, headerStyle),
    summary: {
      borderTop: `1px solid ${theme.border.minimal}`
    },
    body: __spreadProps(__spreadValues({}, theme.typography.body02), {
      padding: emphasisVariant.bodyPadding
    })
  };
}
var accordionSizeVariants = {
  sm: {
    typography: "body03",
    toggleFontSize: "16px",
    toggleRight: "6px",
    toggleTop: "8px",
    paddingRight: 26,
    paddingY: 8
  },
  md: {
    typography: "body02",
    toggleFontSize: "20px",
    toggleTop: "10px",
    toggleRight: "8px",
    paddingRight: 30,
    paddingY: 10
  },
  lg: {
    typography: "body01",
    toggleFontSize: "24px",
    toggleRight: "10px",
    toggleTop: "10px",
    paddingRight: 40,
    paddingY: 10
  }
};
var getAccordionEmphasisVariants = (theme) => {
  const subtleShades = theme.getSurfaceInteractionShades("primary");
  const boldShades = theme.getSurfaceInteractionShades("tertiary");
  return {
    subtle: {
      textColor: theme.text.primary,
      toggleIconColor: theme.text.secondary,
      backgroundColor: "transparent",
      hoverBackgroundColor: subtleShades.hover,
      borderTop: `1px solid ${theme.border.moderate}`,
      borderBottom: "1px solid transparent",
      expandedColor: theme.text.primary,
      expandedBackgroundColor: "transparent",
      paddingX: 0,
      bodyPadding: "4px 0px 12px 0px"
    },
    bold: {
      textColor: theme.text.primary,
      toggleIconColor: theme.text.secondary,
      backgroundColor: boldShades.background,
      hoverBackgroundColor: boldShades.hover,
      borderTop: `1px solid transparent`,
      // For bold accordion the bottom border is the same as the background color.
      // Using a transparent color will reveal the background. Ideally we should use the same
      // color as the surface. Until we have a SurfaceContext to work with, we'll default to
      // the primary surface background color to handle the most common case
      borderBottom: `1px solid ${theme.surface.primary}`,
      expandedColor: theme.text.reversed,
      expandedBackgroundColor: theme.surface.strong,
      paddingX: 12,
      bodyPadding: "4px 12px 12px 12px"
    }
  };
};
var getDisabledAccordionEmphasisVariants = (theme) => ({
  subtle: __spreadProps(__spreadValues({}, getAccordionEmphasisVariants(theme).subtle), {
    backgroundColor: "transparent",
    hoverBackgroundColor: "transparent"
  }),
  bold: __spreadValues({}, getAccordionEmphasisVariants(theme).bold)
});

// components/accordion/common/src/accordion-util.ts
import { cx } from "@gs-ux-uitoolkit-common/style";
var globalAccordionClassPrefix = "gs-accordion";
var globalAccordionPanelClassPrefix = "gs-accordion-panel";
var getAccordionClassNames = (props) => {
  const { overrideClasses, className } = props;
  return cx(className, overrideClasses && overrideClasses.root, globalAccordionClassPrefix);
};
function getAccordionPanelClassNames(props) {
  const { cssClasses, className, overrideClasses } = props;
  return cx(
    cssClasses.root,
    className,
    overrideClasses && overrideClasses.root,
    globalAccordionPanelClassPrefix
  );
}
var getAccordionPanelBodyClassNames = (props) => {
  const { cssClasses, overrideClasses } = props;
  return cx(
    cssClasses.body,
    overrideClasses && overrideClasses.body,
    `${globalAccordionPanelClassPrefix}__body`
  );
};
var getAccordionPanelHeaderClassNames = (props) => {
  const { cssClasses, overrideClasses } = props;
  return cx(
    cssClasses.header,
    overrideClasses && overrideClasses.header,
    `${globalAccordionPanelClassPrefix}__header`
  );
};
var getAccordionPanelSummaryClassNames = (props) => {
  const { cssClasses, overrideClasses } = props;
  return cx(
    cssClasses.summary,
    overrideClasses && overrideClasses.summary,
    `${globalAccordionPanelClassPrefix}__summary`
  );
};
var getAccordionPanelToggleClassNames = (props) => {
  const { cssClasses, overrideClasses } = props;
  return cx(
    cssClasses.toggle,
    overrideClasses && overrideClasses.toggle,
    `${globalAccordionPanelClassPrefix}__toggle`
  );
};
export {
  accordionDefaultProps,
  accordionEmphases,
  accordionPanelDefaultProps,
  accordionPanelStyleSheet,
  accordionSizes,
  accordionStyleSheet,
  getAccordionClassNames,
  getAccordionPanelBodyClassNames,
  getAccordionPanelClassNames,
  getAccordionPanelHeaderClassNames,
  getAccordionPanelSummaryClassNames,
  getAccordionPanelToggleClassNames
};
//# sourceMappingURL=index.mjs.map
